import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { DonationtypeService } from 'src/app/shared/API-Service/services/donationtype.service';
import { DonationmaintypeService } from 'src/app/shared/API-Service/services/donationmaintype.service';
import { DonationCategoryService } from 'src/app/shared/API-Service/services/donation-category.service';

@Component({
  selector: 'app-insert-donation-type',
  templateUrl: './insert-donation-type.component.html',
  styleUrls: ['./insert-donation-type.component.css']
})
export class InsertDonationTypeComponent implements OnInit {
  recordtoupdate: any;
  donationmaintype:any;
  donationcategory:any;
  donationtypeForm : FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _DonationtypeService:DonationtypeService, private _Router:Router, 
    private _FormBuilder:FormBuilder, private _DonationmaintypeService:DonationmaintypeService,
    private _DonationCategoryService:DonationCategoryService) { }

  ngOnInit(): void {
    this.initiate();
    this.getdropdowns();
    this.checkEdit();
  }
getdropdowns(){
this._DonationmaintypeService.GetDonationMainType().subscribe((res) => {
   this.donationmaintype = res.data;
})
this._DonationCategoryService.GetDonationCategory().subscribe((res) => {
  this.donationcategory = res.data;
})
}
checkEdit() {
  this._DonationtypeService.Data.subscribe((res) => {
    if (res != null) {
      this.donationtypeForm = this._FormBuilder.group({
        title: [res.title, Validators.required],
        isNotify: [res.isNotify, Validators.required],
        donationCategoryId: [res.donationCategoryId, Validators.required],
        donationMainTypeId: [res.donationMainTypeId, Validators.required],
      });
      this.update = true;
      this.recordtoupdate = res ;
    
    } else {
      console.log(`not found on data`);
      // this.initiate();
    }
   
  });
}
  initiate(){
    this.donationtypeForm = this._FormBuilder.group({
      title: ['', Validators.required],
      isNotify: ['', Validators.required],
      donationCategoryId: ['', Validators.required],
      donationMainTypeId: ['', Validators.required],
    });
  }
  get fc() {
    return this.donationtypeForm.controls;
  }


  onSubmit(){
    this.button = true;
   if(this.update == false && this.donationtypeForm.status == "VALID"){
  
    this._DonationtypeService.CreateDonationType(this.donationtypeForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationtypeForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.donationtypeForm.status == "VALID"){
    this.donationtypeForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._DonationtypeService.UpdateDonationType(this.donationtypeForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationtypeForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.donationtypeForm.markAllAsTouched();
    this.button = false;
   }
  }


  ngOnDestroy(){
    this._DonationtypeService.Data.next(null);
     }

}
